import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { About, Contact, Faq, Home, PageNotFound, Privacy, Terms } from './pages';
import { Footer, Navbar } from './components';
import { RootState } from './reducers/store';

const App = () => {
  const { modeValue: theme } = useSelector((state: RootState) => state?.modeList);

  return (
    <div className='main-container' id={theme}>
      <Toaster position='top-center' reverseOrder={false} gutter={8} toastOptions={{ className: 'toast-option' }} containerStyle={{top: '15%', }}></Toaster>
        <Navbar theme={theme} />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact-us" element={<Contact />} /> 
          <Route path="/about" element={<About />} />
          
          <Route path="/frequently-asked-questions" element={<Faq />} />
          <Route path='/page-not-found' element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/page-not-found" replace />} />
        </Routes>
      <Footer />
    </div>
  )
}

export default App